const APPLE_WALLET_SVG =
  'https://liveonbeat.s3.us-east-1.amazonaws.com/passes/US-UK_Add_to_Apple_Wallet_RGB_101421.svg'
const GOOGLE_WALLET_SVG =
  'https://liveonbeat.s3.us-east-1.amazonaws.com/passes/enUS_add_to_google_wallet_add-wallet-badge.svg'

function Wallets({
  eventId,
  userEmail,
  text = 'Save your tickets to your phone',
  subtext = 'Tap a wallet button below to add your pass and keep it ready for entry.',
  note = 'If you do not see the wallet screen, make sure you are on your phone.',
}) {
  const badgeClassName =
    'inline-flex items-center justify-center rounded-md transition hover:-translate-y-0.5 hover:shadow-lg'
  const imageClassName = 'h-[36px] w-auto'
  const applePass =
    eventId && userEmail
      ? `https://liveonbeat.com/api/tickets/event/${eventId}/apple/${userEmail}`
      : ''
  const androidPass =
    eventId && userEmail
      ? `https://liveonbeat.com/api/tickets/event/${eventId}/android/${userEmail}`
      : ''

  const renderBadge = (href, src, alt) => {
    const image = <img src={src} alt={alt} className={imageClassName} />

    if (!href) {
      return (
        <span className={badgeClassName} role="img" aria-label={alt}>
          {image}
        </span>
      )
    }

    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={badgeClassName}
      >
        {image}
      </a>
    )
  }

  return (
    <div className="flex flex-col items-center gap-2 border-y border-neutral-200 px-4 pb-3 pt-2 text-center text-black">
      <div className="max-w-xl">
        <p className="text-2xl font-bebas font-semibold leading-tight tracking-wide text-black sm:text-3xl">
          {text}
        </p>
        <p className="mt-0.5 text-xs leading-snug text-black sm:text-sm">{subtext}</p>
        <p className="mt-0.5 text-[11px] leading-snug text-black/70 sm:text-xs">{note}</p>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3">
        {renderBadge(applePass, APPLE_WALLET_SVG, 'Add to Apple Wallet')}
        {renderBadge(
          androidPass,
          GOOGLE_WALLET_SVG,
          'Add to Google Wallet'
        )}
      </div>
    </div>
  )
}

export default Wallets